import { render, staticRenderFns } from "./popup-brand.vue?vue&type=template&id=aa4c3d28&"
import script from "./popup-brand.vue?vue&type=script&lang=js&"
export * from "./popup-brand.vue?vue&type=script&lang=js&"
import style0 from "./popup-brand.vue?vue&type=style&index=0&id=aa4c3d28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports